import React from "react";
import TeamRosterCard from "./components/TeamRosterIndex";

const TeamRoster = () => <TeamRosterCard />;

export default TeamRoster;
